export * from '@primeuix/themes/aura/treetable';
export { default } from '@primeuix/themes/aura/treetable';
